
import { mapState } from "vuex";
import OrderDurationGraph from "../common/order-duration-graph.vue";

export default {
  components: { OrderDurationGraph },
  data() {
    return {
      deliveryData: [
        { label: "Rider Name", data: "customer_name" },
        { label: "Rider Contact", data: "partner_order_id" },
        { label: "Picked Up Time", data: "customer_name" }
      ],
      started_at: "",
      accepted_at: "",
      ready_at: "",
      dispatched_at: "",
      completed_at: "",
      defaultDelay: 0,
      emptyDateTimeCount: 1
    };
  },
  mounted() {
    this.extractDateTimeInfo();
  },
  computed: {
    ...mapState("reciever", ["orderDetails"]),
    orderTotalDuration() {
      return (
        Number(
          this.orderDetails.accepted_at
            ? this.getDateTimeDifferenceInSeconds(
                this.orderDetails.started_at,
                this.orderDetails.accepted_at
              )
            : this.defaultDelay
        ) +
        Number(
          this.orderDetails.ready_at
            ? this.getDateTimeDifferenceInSeconds(
                this.orderDetails.accepted_at,
                this.orderDetails.ready_at
              )
            : this.defaultDelay
        ) +
        Number(
          this.orderDetails.dispatched_at &&
            this.orderDetails.order_type !==
              this.$constants.OrderTypes.TAKE_AWAY.id
            ? this.getDateTimeDifferenceInSeconds(
                this.orderDetails.ready_at,
                this.orderDetails.dispatched_at
              )
            : this.defaultDelay
        ) +
        Number(
          this.orderDetails.completed_at &&
            this.orderDetails.order_type ===
              this.$constants.OrderTypes.TAKE_AWAY.id
            ? this.getDateTimeDifferenceInSeconds(
                this.orderDetails.ready_at,
                this.orderDetails.completed_at
              )
            : this.defaultDelay
        ) +
        Number(
          this.orderDetails.completed_at &&
            this.orderDetails.order_type !==
              this.$constants.OrderTypes.TAKE_AWAY.id
            ? this.getDateTimeDifferenceInSeconds(
                this.orderDetails.dispatched_at,
                this.orderDetails.completed_at
              )
            : this.defaultDelay
        )
      );
    },
    getPickedUpTime() {
      if (
        this.orderDetails.order_type === this.$constants.OrderTypes.TAKE_AWAY.id
      ) {
        return this.orderDetails.completed_at
          ? this.getFormattedTimeDifference(
              this.orderDetails.ready_at,
              this.orderDetails.completed_at
            )
          : this.defaultDelay + " Min";
      } else {
        return this.orderDetails.dispatched_at
          ? this.getFormattedTimeDifference(
              this.orderDetails.ready_at,
              this.orderDetails.dispatched_at
            )
          : this.defaultDelay + " Min";
      }
    }
  },
  watch: {
    orderDetails(val) {
      this.extractDateTimeInfo();
    }
  },
  methods: {
    extractDateTimeInfo() {
      this.started_at = this.orderDetails.started_at;
      this.accepted_at = this.getEventTime(
        this.orderDetails.accepted_at,
        this.started_at
      );
      this.ready_at = this.getEventTime(
        this.orderDetails.ready_at,
        this.accepted_at
      );
      this.dispatched_at = this.getEventTime(
        this.orderDetails.dispatched_at,
        this.ready_at
      );
      this.completed_at = this.getEventTime(
        this.orderDetails.completed_at,
        this.dispatched_at
      );
    },
    getEventTime(dateTime, prevDateTime) {
      return (
        dateTime || false
        // new Date(new Date(prevDateTime).getTime() + this.defaultDelay * 60000)
      );
    }
  }
};
